import addRoute from '@/router/add-route';

const Dashboard = () => import('@/modules/dashboard/dashboard.vue');

const dashboard = [
    addRoute({
        name: 'dashboard',
        component: Dashboard,
    }),
];

export default dashboard;
